var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"capitalize",rawName:"v-capitalize"}],attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.rdaChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }